import { apiClient } from './apiClient'
import { encryptField } from '../utils/encryption';
import { enqueueSnackbar } from 'notistack';
import { useNavigate } from "react-router-dom";

class ForgotPassword{
    async checkExitsEmail(email){
        try {
             const response = await apiClient.post('/api/register/check-email',{
            email
        })
        return response.data.exists
        } catch (error) {
            if(error.response?.status === 400){
                enqueueSnackbar("Email does not exits", {variant:"success"})
            }
            throw new Error("Invalid Email", error.message)
        }
       
    }
    // Send otp 
    async sendOtp(formData){
       /* for generate otp in frontend */ 
    //    const newOtp = Math.floor(1000 + Math.random() * 9000).toString();

       try {
        // console.log("Sending Otp", formData.email)

       const response = await apiClient.post("/api/send-email-otp",{
            email : formData.email,    
            //   sent otp using frontend      
            // otp : newOtp.toString()
       })
       return response
/* Return the OTP so we can store it in state for verification */
    //    return newOtp; 
       } catch (error) {
         // Handle different error cases
            if (error.response?.status === 400) {
                throw new Error("Invalid email address");
            } else if (error.response?.status === 404) {
                throw new Error("Email not found");
            } else if (error.response?.status === 429) {
                throw new Error("Too many attempts. Please try again later.");
            } else {
                throw new Error("Failed to send OTP. Please try again.");
            }

       }
    }

    async verifyOtpAndReset (formData){
        try {
           const response = await apiClient.post('/api/users/reset-password',{
            email : formData.email,
            otp: formData.otp,
            newPassword : formData.password
        })
        if(response.data.success){
            enqueueSnackbar("Password Reset Successfully", {variant:"success"})
            return true
        }else{
            enqueueSnackbar("Failed to reset password", {variant:"error"});
        }
        } catch (error) {
            
             throw new Error("Failed to Reset password. Please try again.");
        }
    }

    async updatePassword(formData){
        
        try {
            const response = await apiClient.put('/api/user/update-password',{
                email : formData.email,
                newPassword : formData.password
            })
            if(response.data.success){
                enqueueSnackbar("Password updated succesfully", {variant:"success"})
                // navigate("/studentlogin")
            }
        } catch (error) {
            enqueueSnackbar("Failed to reset password", {variant:"error"});
            throw new Error("Failed to reset password", error.message)
        }
    }

    
}

export const forgotPasswordService = new ForgotPassword()